/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteEvalSuiteRequest = {
  suiteId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteEvalSuiteRequest$inboundSchema: z.ZodType<
  DeleteEvalSuiteRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  suite_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "suite_id": "suiteId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteEvalSuiteRequest$Outbound = {
  suite_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteEvalSuiteRequest$outboundSchema: z.ZodType<
  DeleteEvalSuiteRequest$Outbound,
  z.ZodTypeDef,
  DeleteEvalSuiteRequest
> = z.object({
  suiteId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    suiteId: "suite_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteEvalSuiteRequestToJSON(
  deleteEvalSuiteRequest: DeleteEvalSuiteRequest,
): string {
  return JSON.stringify(
    DeleteEvalSuiteRequest$outboundSchema.parse(deleteEvalSuiteRequest),
  );
}
export function deleteEvalSuiteRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteEvalSuiteRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteEvalSuiteRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteEvalSuiteRequest' from JSON`,
  );
}
